/**
 * Module-level record of an in-flight `services_restart` that takes
 * botman down. Host commands are fired from many unrelated components
 * (equipment manager, settings, feature-flag banner, bot ID card), so
 * the flag lives here rather than in any one component tree; consumers
 * (the agent chat composer) subscribe through
 * {@link subscribeServicesRestarting}.
 *
 * Marking happens in `executeHostCommand`; clearing is the consumer's
 * job (it watches the botman connection recover) via
 * {@link clearServicesRestarting}.
 */

let restartingSince: number | null = null;

const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) {
    listener();
  }
}

/** Epoch ms when the current restart was requested, or null. */
export function getServicesRestartingSince(): number | null {
  return restartingSince;
}

export function markServicesRestarting(): void {
  // Always take the new timestamp: a restart fired while one is
  // already pending should extend the window, not inherit the old
  // clock.
  restartingSince = Date.now();
  notify();
}

export function clearServicesRestarting(): void {
  if (restartingSince === null) return;

  restartingSince = null;
  notify();
}

export function subscribeServicesRestarting(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}
